export default __webpack_public_path__ + "static/media/logo-white.127c4afc.svg";